export function createArray(length: number): number[] {
  return Array.from({ length }, (_, index) => index);
}
